<template>
	<div class="full">
		<vxe-table :loading="loading" :data="data" height="90%" border :tooltip-config="{showAll:true}"
			:merge-cells="mergeCells">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="contnet" title="操作项">
				<template #default="{ row }">
					<span>{{parselogAction(row.action)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="contnet" title="操作内容">
				<template #default="{ row }">
					<span>{{parselogonContent(row.action,row.param)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="staffid" title="操作人">
				<template #default="{ row }">
					<span>{{$systemMethods.getstaff(row.staffid)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="departmentid" title="操作时间">
				<template #default="{ row }">
					<span>{{$systemMethods.timestampToDate(row.create_time)}}</span>
				</template>
			</vxe-column>
		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'salesstaticIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				data: [],
				mergeCells: [{
					row: 0,
					col: 5,
					rowspan: 3,
					colspan: 0
				}],
				loading: false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			if (this.row) {
				this.getLog()
			}
		},
		computed: {

		},

		methods: {
			getLog() {
				this.loading = true
				this.$api.log.list({
					dataid: this.row.id,
					formname:'c_crmcustomer'
				}).then((res) => {
					this.data = res
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			parselogAction(action){
				if(action=='distribution'){
					return '分配'
				}
				return ''
			},
			parselogonContent(action,param){
				if(action=='distribution'){
					return this.$systemMethods.getstaff(param.staffid)
				}
				return ''
				
			}

		},
		components: {

		}
	}
</script>